import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-89" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-90" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-91" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "'Open Sans', sans-serif",
        fontSize: "26px",
        color: "#6E3CC4",
        fontWeight: "800"
      }} data-id="element-92" data-mp="s9zzhikkb8n9">
          A CLEARER ROUTINE, STEP BY STEP
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px",
        color: "#232C43"
      }} data-id="element-93" data-mp="381e25e7i07uk">
          The visual roadmap to end morning chaos and bedtime battles without nagging, shouting, or stress.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-94" data-mp="399jlt944m740">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-95" data-mp="358zoo5jjz3hv" />
          <img src="https://cdn.magicpatterns.com/uploads/bWk7w7XFTzStYPY94L51pN/ChatGPT_Image_5_sept_2026,_15_00_13.png" alt="The Autonomous Child Visual System — complete eBook plus 5 bonuses in digital format" width={1248} height={1248} className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" data-id="element-96" data-mp="2qloea6z3xpjc" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-97" data-mp="s2b8o0ipgn67">
          ⭐ 4.9 (500+ families using visual routines) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-98" data-mp="degcub9ei2ow">
          <CTAButton href="#value" data-id="element-99" data-mp="1b0nizplcs33d">See the system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-100" data-mp="1ayt7t2zvvpch">
            THE AUTONOMOUS CHILD VISUAL SYSTEM™ helps you organize morning, afternoon and bedtime
            activities so that each step of the day can be seen clearly and understood by your
            child.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-101" data-mp="x3h0lw4jk6eo">
            One thing at a time · Fully customizable · <span className="text-blush" data-id="element-102" data-mp="21awdg8y8grgf">No monthly subscription</span>
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-103" data-mp="218jzs7zid396">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-104" data-mp="2b1r8o2tgj1e0">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-105" data-mp="2kydtirls9sg1" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-106" data-mp="2p1jzrz8wbjmi">
            eBook + 5 bonuses · Morning · Afternoon · Night.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-107" data-mp="umhc873eqbm8">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-108" data-mp="zndq9dhh3e5d">
              <Icon className="h-4 w-4 text-grape" data-id="element-109" data-mp="49jco3qr0lll" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-110" data-mp="3vjrsyaf7ttrj">
          🔥 Limited-time offer · Then the price goes back up to $54
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-111" data-mp="3rhn4dq3mjnbr">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-112" data-mp="3mnafh0jdpjsm" />
          25 families are looking at this product right now
        </p>
      </div>
    </header>;
}